import { render, staticRenderFns } from "./productPerformanceByPercentage.vue?vue&type=template&id=13cc15d9&"
import script from "./productPerformanceByPercentage.vue?vue&type=script&lang=js&"
export * from "./productPerformanceByPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports